<script lang="ts" setup>
import { BreadcrumbsProps } from "~/components/Utils/Breadcrumbs.props"
import { ListPostsProps } from "~/components/Grid/ListPosts.props"
import { customPaths } from "~/utils/constants"
import { SeoBaseProps } from "~/components/seo/Base.props"

const { t } = useI18n()

const posts: ListPostsProps = reactive({
  title: t("magazine.allPostsOfTopMagazine"),
  postsList: [],
  totalPosts: 0
})

const { data: getFirstPosts, error: errorGetFirstPosts } = await useFetch(
  `/api/magazine/getPostsPagination/0/12`,
  {
    method: "GET"
  }
)

if (errorGetFirstPosts.value) {
  console.warn("error get first posts", errorGetFirstPosts.value)
} else {
  posts.postsList = getFirstPosts?.value?.posts
  posts.totalPosts = getFirstPosts?.value?.total
}

const breadcrumbs: ComputedRef<BreadcrumbsProps> = computed(() => ({
  links: [
    {
      label: "Home",
      to: "/"
    },
    {
      label: "Top Magazine",
      to: customPaths.magazineRoot
    }
  ],
  currentPage: t("magazine.breadcrumbs.AllPosts")
}))

const seo = {
  metaTitle: "Top Magazine: tutti i post"
}
const seoData = computed((): SeoBaseProps => {
  return {
    metaTitle: t("magazine.allPostsOfTopMagazine")
  }
})
</script>

<template>
  <SeoBase v-if="seo" v-bind="seo" />
  <div v-if="posts.postsList && posts.postsList.length > 0">
    <SeoBase v-if="seoData" v-bind="seoData" />
    <PagesPosts
      :postsList="posts"
      :breadcrumbsLinks="breadcrumbs"
      :hasDropdownCategory="false"
    />
  </div>
</template>
